import { useState } from 'react'
import { tournamentApi } from '../services/api'

// Default money formatter; overridable via prop so each page keeps its style.
const defaultMoney = (v, cur = 'CAD') => (v == null ? '' : `${cur} ${Number(v).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`)

// Net-rate (concierge) hotel confirm form — shared by the reseller Bookings
// detail page and the "To book" worklist. Records the property confirmation
// number and, for issue_refunds holders, an optional amount actually paid
// (blank keeps the parked cost). POSTs the deployed confirm-net-rate route.
export default function NetRateConfirmForm({ bookingId, sequence, parkedCost, currency, canIssueRefunds, onDone, t, fmtMoney = defaultMoney }) {
  const [confNum, setConfNum] = useState('')
  const [amount, setAmount] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState(null)
  const inp = { padding: '6px 8px', border: '1px solid #cbd5e1', borderRadius: 6, fontSize: 12.5 }
  async function submit() {
    const conf = confNum.trim()
    if (!conf) { setErr(t('sp_nr_need_conf', 'Enter the property confirmation number.')); return }
    const raw = amount.trim()
    let amountPaid
    if (canIssueRefunds && raw !== '') {
      const n = Number(raw)
      if (!Number.isFinite(n) || n < 0) { setErr(t('sp_nr_amount_bad', 'Enter a valid amount (0 or more).')); return }
      amountPaid = n
    }
    setBusy(true); setErr(null)
    try {
      await tournamentApi.post(`/portal/reseller/bookings/${bookingId}/hotels/${sequence}/confirm-net-rate`,
        amountPaid === undefined ? { confirmationNumber: conf } : { confirmationNumber: conf, amountPaid })
      await onDone()
    } catch (e) { setErr(e?.response?.data?.message || e.message); setBusy(false) }
  }
  return (
    <div style={{ marginTop: 10, padding: '10px 12px', background: '#f5f3ff', border: '1px solid #ddd6fe', borderRadius: 8 }}>
      <div style={{ fontSize: 12.5, fontWeight: 700, color: '#5b21b6', marginBottom: 6 }}>
        📋 {t('sp_nr_confirm_heading', 'Net-rate property — confirm the room with the property, then record it here')}
      </div>
      {parkedCost != null && (
        <div style={{ fontSize: 11.5, color: '#7c6ba8', marginBottom: 6 }}>
          {t('sp_nr_net_hint', 'Quoted cost to pay the property: {amount}', { amount: fmtMoney(parkedCost, currency) })}
        </div>
      )}
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <label style={{ fontSize: 12.5, color: '#475569', display: 'flex', gap: 6, alignItems: 'center' }}>{t('sp_nr_conf_number', 'Confirmation number')}
          <input type="text" value={confNum} onChange={e => setConfNum(e.target.value)} placeholder={t('sp_nr_conf_ph', 'e.g. Cabot #AB123')} style={{ ...inp, width: 160 }} /></label>
        {canIssueRefunds && (
          <label style={{ fontSize: 12.5, color: '#475569', display: 'flex', gap: 6, alignItems: 'center' }}>{t('sp_nr_amount_paid', 'Amount paid to property (optional)')}
            <input type="number" min="0" step="0.01" value={amount} onChange={e => setAmount(e.target.value)} style={{ ...inp, width: 120 }} /></label>
        )}
        <button onClick={submit} disabled={busy} style={{ padding: '7px 14px', borderRadius: 6, fontWeight: 700, fontSize: 12.5, border: 'none', background: '#6d28d9', color: '#fff', cursor: busy ? 'default' : 'pointer' }}>
          {busy ? t('sp_nr_confirming', 'Confirming…') : t('sp_nr_confirm_btn', 'Confirm net-rate hotel')}
        </button>
      </div>
      {canIssueRefunds && (
        <div style={{ marginTop: 6, fontSize: 11, color: '#7c6ba8' }}>{t('sp_nr_amount_help', 'Leave blank unless the property charged a different amount than quoted.')}</div>
      )}
      {err && <div style={{ marginTop: 6, fontSize: 12, color: '#991b1b' }}>{err}</div>}
    </div>
  )
}
